module.exports = __webpack_public_path__ + "static/pause-8bb2c3933bcfafb26cbcd7f297d3685d.png";